import { FC, useState } from 'react'

// config
import { maxReportComplaintLength, complaintTypeSelectOptions } from '@/config'
// hooks
import { useAppSelector, useAppDispatch } from '@/hooks'
// features
import {
  authSelectProfile,
  reportSelectReportCreateTrackReportComplaintLoading,
  reportSelectReportTrackModalTrack,
  reportCreateTrackReportComplaint,
} from '@/features'
// utils
import { validateReportComplaint } from '@/utils'
// components
import { Loader, ButtonLarge, InputArea, InputSelect } from '@/components'

// styles
import { styles } from './styles'

type ReportTrackFormProps = {}

export const ReportTrackForm: FC<ReportTrackFormProps> = () => {
  const dispatch = useAppDispatch()
  const reportCreateTrackReportComplaintLoading = useAppSelector(
    reportSelectReportCreateTrackReportComplaintLoading,
  )
  const profile = useAppSelector(authSelectProfile)
  const modalTrack = useAppSelector(reportSelectReportTrackModalTrack)

  const [complaintType, setComplaintType] = useState<string>('')
  const [complaint, setComplaint] = useState('')
  const [complaintError, setComplaintError] = useState('')

  const { id: profileUserId } = profile ?? {}
  const { userId: artistUserId } = modalTrack ?? {}

  const isCurrentUserTrack = profileUserId === artistUserId

  const submitDisabled =
    complaint.length > maxReportComplaintLength ||
    !complaintType ||
    isCurrentUserTrack ||
    reportCreateTrackReportComplaintLoading

  return (
    <div css={styles().form.main}>
      <form
        css={styles().form.content.main}
        onSubmit={(e) => {
          e.preventDefault()
          dispatch(
            reportCreateTrackReportComplaint({
              complaintType,
              complaint,
            }),
          )
        }}
      >
        <div css={styles().form.content.type}>
          <InputSelect
            placeholder={{
              id: 'report-track-select-placeholder',
              label: 'Select complaint type',
              value: 'select_complaint_type',
            }}
            options={complaintTypeSelectOptions}
            setValue={(value: string) => setComplaintType(value)}
          />
        </div>
        <div css={styles().form.content.complaint}>
          <InputArea
            name="report-complaint"
            label="report complaint"
            id="report-complaint"
            placeholder="Describe the details of your concern"
            value={complaint}
            maxLength={maxReportComplaintLength}
            error={complaintError.length > 0}
            errorMessage={complaintError}
            rows={6}
            onChange={(e) => setComplaint(e.target.value)}
            onBlur={() => {
              if (complaint !== '') {
                setComplaintError(validateReportComplaint(complaint))
              }
            }}
            onFocus={() => setComplaintError('')}
          />
        </div>
        <div css={styles().form.content.submit}>
          <ButtonLarge
            type="submit"
            aria-label="create complaint"
            disabled={submitDisabled}
            appearance="primary"
          >
            {reportCreateTrackReportComplaintLoading ? (
              <Loader width={50} height={20} appearance="primary" />
            ) : (
              `Report`
            )}
          </ButtonLarge>
        </div>
      </form>
    </div>
  )
}

ReportTrackForm.propTypes = {}
